import { Box, Button, Link, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';
import '../styles/qualtrics.css';

function isValidUrl(value) {
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

function Qualtrics() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const qualtricsUrl = String(process.env.REACT_APP_QUALTRICS_URL || '').trim();
  if (!isValidUrl(qualtricsUrl)) {
    throw new Error('Invalid or missing REACT_APP_QUALTRICS_URL');
  }

  return (
    <Box className="qualtrics">
      <Paper elevation={3} className="qualtrics__paper">
        <Typography variant="h5" className="qualtrics__title">
          {t('qualtrics.title')}
        </Typography>

        <Typography variant="body1" className="qualtrics__instructions">
          {t('qualtrics.instructions')}
        </Typography>

        <Box className="qualtrics__qrSection">
          <Box className="qualtrics__qrWrap">
            <QRCodeCanvas
              value={qualtricsUrl}
              size={280}
              marginSize={4}
              level="M"
              aria-label={t('qualtrics.qrAriaLabel')}
            />
          </Box>

          <Link
            href={qualtricsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="qualtrics__link"
            aria-label={t('qualtrics.linkAriaLabel')}
          >
            {t('qualtrics.link')}
          </Link>
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/', { replace: true })}
          aria-label={t('qualtrics.exitAriaLabel')}
        >
          {t('qualtrics.exitButton')}
        </Button>
      </Paper>
    </Box>
  );
}

export default Qualtrics;
